// extracted by mini-css-extract-plugin
module.exports = {"root":"TableCell-root-XydbM","header":"TableCell-header-65l3q","body":"TableCell-body-n2wPO","alignCenter":"TableCell-alignCenter-3MnzU","alignEnd":"TableCell-alignEnd-3kdR1"};